import * as React from 'react';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { P } from '../../../designSystem/typography/Body';
import { H3 } from '../../../designSystem/typography/Heading';
import { DashboardCard } from './DashboardCard';


export function DashboardFactCard(props: { portal?: boolean }): JSX.Element {

const facts = [
        {   
            title: "Kontorplanter kan øge produktiviteten med op til 15 %", 
            description: "Studier viser, at bare synet af grønne planter på arbejdspladsen kan mindske stress og øge både koncentration og trivsel.",
            category: "Diverse"
        },
        {
            title: "Stående møder varer gennemsnitligt 34 % kortere end siddende møder.", 
            description: "Og de er ofte mere fokuserede – fordi ingen gider stå og smalltalke i 30 minutter.",
            category: "Diverse"
        },
        {
            title: "Lys påvirker dit humør og din døgnrytme markant.", 
            description: "Dårlig belysning på arbejdspladsen kan føre til træthed, hovedpine og lavt energiniveau – mens godt lys kan forbedre både søvn og fokus.",
            category: "Diverse"
        },
        {
            title: "Baggrundsstøj på kontoret kan mindske arbejdseffektivitet med op til 66 %.", 
            description: 'Især gentagen støj som telefoner eller kollegaer, der snakker – det kaldes også "open office fatigue".',
            category: "Diverse"
        },
        {
            title: "Glade medarbejdere er op til 20 % mere produktive.", 
            description: "Arbejdsmiljø og trivsel er ikke kun nice-to-have – det har direkte indflydelse på både præstation og bundlinje.",
            category: "Diverse"
        },
        {
            title: "Glade medarbejdere er op til 20 % mere produktive",
            description: "Et godt psykisk arbejdsmiljø bidrager til øget engagement, lavere sygefravær og højere effektivitet.",
            category: "Psykisk arbejdsmiljø"
        },
        {
            title: "Ros og anerkendelse styrker både arbejdsglæde og samarbejde",
            description: "Selv små former for anerkendelse øger følelsen af værdi og tilhørsforhold i teamet.",
            category: "Psykisk arbejdsmiljø"
        },
        {
            title: "Mikropauser kan reducere mental udmattelse markant",
            description: "Bare 1-2 minutters pause væk fra skærmen hvert 30. minut hjælper hjernen med at holde fokus længere.",
            category: "Psykisk arbejdsmiljø"
        },
        {
            title: "Manglende indflydelse på egne opgaver øger stressniveauet",
            description: "Medarbejdere, der føler sig magtesløse i deres arbejde, har højere risiko for udbrændthed og lavere motivation.",
            category: "Psykisk arbejdsmiljø"
        },
        {
            title: "Humør smitter – også på arbejdspladsen",
            description: "Positive kollegaer og god stemning øger den generelle trivsel og kan reducere konflikter og misforståelser.",
            category: "Psykisk arbejdsmiljø"
        },
        {
            title: "Fleksible arbejdstider kan øge produktiviteten med op til 13 %",
            description: "Folk, der arbejder hjemme med fleksibilitet, rapporterer ofte højere fokus og færre afbrydelser.",
            category: "Hjemmearbejde"
        },
        {
            title: "Isolation er en af de største udfordringer ved hjemmearbejde",
            description: "Manglende social kontakt kan påvirke både trivsel og tilknytning til arbejdspladsen negativt.",
            category: "Hjemmearbejde"
        },
        {
            title: "Klare rutiner forbedrer balancen mellem arbejde og fritid",
            description: "At opretholde faste start- og sluttider kan hjælpe med at undgå udviskningen mellem arbejds- og privatliv.",
            category: "Hjemmearbejde"
        },
        {
            title: "Virtuelle møder udmatter hjernen hurtigere end fysiske møder",
            description: "‘Zoom fatigue’ skyldes konstant øjenkontakt, manglende kropssprog og forsinkelser i lyd/billede.",
            category: "Hjemmearbejde"
        },
        {
            title: "Et dedikeret arbejdsområde forbedrer fokus",
            description: "Når man arbejder samme sted hver dag, associerer hjernen det med 'arbejdstid' – og det forbedrer koncentrationen.",
            category: "Hjemmearbejde"
        },
        {
            title: "Forkert siddestilling kan give smerter efter kun 20 minutter",
            description: "Dårlig ergonomi foran computeren fører hurtigt til spændinger i nakke, skuldre og ryg.",
            category: "Ergonomi"
        },
        {
            title: "Hæv-sænk-borde kan reducere rygsmerter med op til 32 %",
            description: "Vekslen mellem siddende og stående arbejde aktiverer musklerne og forbedrer blodcirkulationen.",
            category: "Ergonomi"
        },
        {
            title: "Skærmen skal være i øjenhøjde – ellers overbelastes nakken",
            description: "En for lav skærm får hovedet til at hælde frem, hvilket kan give spændingshovedpine og træthed.",
            category: "Ergonomi"
        },
        {
            title: "Ergonomiske mus og tastaturer forebygger musearm",
            description: "Korrekte hjælpemidler reducerer belastningen på håndled og underarme ved gentaget computerarbejde.",
            category: "Ergonomi"
        },
        {
            title: "Bevægelse i løbet af dagen er afgørende – selv små pauser tæller",
            description: "At rejse sig, strække sig eller gå i få minutter hver time mindsker risikoen for stillesygdomme.",
            category: "Ergonomi"
        }
    ];

    const shuffledFacts = facts
    .map(f => ({ fact: f, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(f => f.fact)
    .slice(0, 1);

    return (
        <DashboardCard shadow backgroundColor="white">
            <Flex flexDirection="column" gap={24}>
            {!props.portal && <H3>Vidste du at...</H3>}
            
            {shuffledFacts.map((fact, idx) => (
                <div key={idx}>
                    {props.portal ? (
                            <>
                            <P fontSize="small">{fact.title}</P>
                            <P fontSize="small" style={{marginBottom: 0}}>{fact.description}</P>
                            </>
                        ) : (
                        <>
                        <P><b>{fact.title}</b></P>
                        <P>{fact.description}</P>
                        </>
                        )
                    }
                    
                </div>
            ))}
            </Flex>
        </DashboardCard>
    );
}
